import React from "react";

interface CheckIconProps {
  width?: number | string;
  height?: number | string;
}

const CheckIcon: React.FC<CheckIconProps> = ({ width = 14, height = 14 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="#4caf50" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export default CheckIcon;
